export default __webpack_public_path__ + "static/media/check-done.cbb8da98.svg";